"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "sizes", {
    enumerable: true,
    get: function() {
        return sizes;
    }
});
const sizes = {
    xs: 16,
    sm: 24,
    md: 32,
    lg: 64,
    xl: 128
};

//# sourceMappingURL=sizes.js.map